import { FC } from 'react';
import styles from './bt-chip-list.module.scss';

type Props = {
  labels: string[],
};

const BtChipList: FC<Props> = ({ labels }) => (
  <div className={styles.chips}>
    {labels.map(label => (
      <span key={label} className={styles.chip}>
        {label}
      </span>
    ))}
  </div>
);

export default BtChipList;
